import {Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'custom-icon-btn',
  templateUrl: './custom-icon-btn.component.html',
  styleUrls: ['./custom-icon-btn.component.scss'],
})
export class CustomIconBtnComponent implements OnInit {
  @Input()
  color?: String;

  @Input()
  iconColor?: String;

  @Input()
  btnClasses?: String;

  @Input()
  iconClasses?: String;

  @Input()
  fontSize?: String;

  @Input()
  disabled: Boolean = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  @HostBinding('class')
  get hostClass(): string {
    return this.disabled ? 'disabled' : 'enabled';
  }


}
